import { motion } from "framer-motion";
import { Reveal, EASE } from "./Reveal";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="section-manifesto"
      className="relative overflow-hidden border-y border-white/5 bg-[#080D1F] py-24 lg:py-32"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/2 h-[560px] w-[860px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#1B6EF3]/12 blur-[150px]" />
        <div className="noise absolute inset-0 opacity-50" />
      </div>

      <div className="relative mx-auto flex max-w-4xl flex-col items-center gap-8 px-5 text-center sm:px-8">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-cyan-400/25 bg-cyan-400/10 px-4 py-1.5 font-mono text-xs uppercase tracking-[0.2em] text-cyan-300">
            Manifesto del brand
          </span>
        </Reveal>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, ease: EASE }}
          className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl"
          data-testid="manifesto-titolo"
        >
          La tecnologia mette ordine.{" "}
          <span className="text-gradient">Il fattore umano ti dà fiducia.</span>
        </motion.h2>

        <Reveal delay={0.15}>
          <div className="max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            <p>
              Crediamo che gestire una Partita IVA non debba significare diventare esperti di burocrazia. Per questo
              abbiamo creato uno strumento semplice, capace di rendere più immediate le attività quotidiane e di
              avvicinare ogni persona al professionista che la segue.
            </p>
            <p className="mt-4">
              Human Factor nasce dall'incontro tra tecnologia e competenza: la prima rende tutto più efficiente, la
              seconda ti aiuta a prendere decisioni con maggiore consapevolezza.
            </p>
          </div>
        </Reveal>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.25, ease: EASE }}
          className="max-w-3xl font-display text-xl font-bold leading-snug sm:text-2xl"
          data-testid="manifesto-chiusura"
        >
          Perché dietro ogni Partita IVA non c'è una pratica.{" "}
          <span className="text-gradient">C'è una persona che lavora, progetta e costruisce il proprio futuro.</span>
        </motion.p>

        <Reveal delay={0.3}>
          <img
            src="/hf-logo-extended.webp"
            alt="Human Factor"
            className="mt-4 h-20 w-auto rounded-2xl bg-white px-7 py-3.5 shadow-2xl shadow-black/50 ring-1 ring-white/20 sm:h-24"
          />
        </Reveal>
      </div>
    </section>
  );
}
